// @flow

// $FlowFixMe[cannot-resolve-module] -- modernizr doesn't have types
import Modernizr from 'modernizr';
import $ from 'jquery';
import Bacon from 'baconjs';
$.fn.asEventStream = Bacon.$.asEventStream;

/**
 * Pushes the given results and search parameters to History API and changes the
 * URL to match those parameters.
 *
 * @param {Object} state - The new state to be set
 * @param {Object} state.params - The corresponding parameters for the state
 */
export function pushState(state: any) {
  if (!Modernizr.history) return;

  const queryParams = decodeURIComponent($.param(state.params || {}));
  let url = window.location.pathname;
  if (queryParams) {
    url += `?${queryParams}`;
  }

  window.history.pushState(state, null, url);
}

/**
 * Replaces the current History API state to match the given values.
 *
 * @param {Object} newState - The state to be set
 * @param {Object} newState.params - The corresponding parameters for the state
 */
export function replaceState(newState: any) {
  if (!Modernizr.history) return;

  window.history.replaceState(newState, null, null);
}

/**
 * Hooks the given callback to History API popstate events.
 *
 * @param {popStateCallback} callback - The callback that handles the new state.
 */
export function onPopState(callback: (state: any) => mixed) {
  $(window)
    .asEventStream('popstate')
    .map('.originalEvent')
    .filter('.state')
    .map('.state')
    .onValue(callback);
}

/**
 * A callback handling a new state from popState event
 * @callback popStateCallback
 *
 * @param {Object} state - The state received from popState event
 * @param {Object} state.params - The corresponding parameters for the state
 */
